import { memo } from 'react';

import { Box, LabelDeal, LabelNew, LabelTop } from '@core/component';
import { useContextMediaQuery } from '@core/context';
import { ESize, EZIndexName } from '@core/type';

import { ProductCarouselLabelsProps } from '../interface-product';
import { MOBILE_IMAGE_SIZE } from './constants';

export const ProductCarouselLabelsContainer = ({
  isNew,
  isTopSales,
  deal,
  isOutOfStock,
  isEnabled,
}: ProductCarouselLabelsProps) => {
  const { isMobile, isDesktop, mediaQuery } = useContextMediaQuery();

  if (!(isNew || isTopSales || (deal && !isOutOfStock && isEnabled))) {
    return null;
  }

  const labelSize = isMobile ? ESize.MD : ESize.LG;

  return (
    <Box
      left={
        isDesktop && mediaQuery !== ESize.LG
          ? '48px'
          : isMobile
            ? `calc(100% / 2 - ${MOBILE_IMAGE_SIZE} / 2)`
            : '0'
      }
      top={0}
      maxWidth={'fit-content'}
      position="absolute"
      pointerEvents="none"
      zIndex={EZIndexName.OVER_DEFAULT}
    >
      {deal ? (
        <LabelDeal labelSize={labelSize} percentage={deal.percentage} />
      ) : (
        <>
          {isNew && !isTopSales && <LabelNew labelSize={labelSize} />}
          {isTopSales && <LabelTop labelSize={labelSize} />}
        </>
      )}
    </Box>
  );
};

export const ProductCarouselLabels = memo(ProductCarouselLabelsContainer);
